import { useQuery } from 'react-query';
import { sendEnforceMFAOtp } from '../apiCalls';
import { QueryKey } from './QueryKeys';

// TODO Figure out if this can be combined into one endpoint with sendMFAOtp

const useSendEnforceMFAOtp = (
	apiEnvironment,
	mfaToken,
	medium,
	enabled,
	onSuccess,
	onError = () => {}
) => {
	const { isLoading, isError } = useQuery(
		[QueryKey.GET_ENFORCE_MFA_OTP, apiEnvironment, mfaToken, medium, enabled],
		sendEnforceMFAOtp,
		{
			enabled,
			onSuccess,
			onError,
		}
	);

	return {
		isLoading,
		isError,
	};
};

export default useSendEnforceMFAOtp;
